import getGoogleMapMarkerIconByType, {
    GoogleMapMarkerIconProps,
} from "@store/Framework/Common/Utilities/googleMap/getGoogleMapMarkerIconByType";
import { IconDefinitionProps } from "@store/Framework/Types/Icon";
import { useTheme } from "styled-components";

function useGoogleMapMarkerIconByType(
    markerType: Toolkit.Theme.GoogleMap.MarkerType,
    iconDefinition?: IconDefinitionProps,
    inline?: false,
): (props: GoogleMapMarkerIconProps) => JSX.Element;

function useGoogleMapMarkerIconByType(
    markerType: Toolkit.Theme.GoogleMap.MarkerType,
    iconDefinition?: IconDefinitionProps,
    inline?: true,
): string;

function useGoogleMapMarkerIconByType(
    markerType: Toolkit.Theme.GoogleMap.MarkerType,
    iconDefinition?: IconDefinitionProps,
    inline?: boolean,
): string | ((props: GoogleMapMarkerIconProps) => JSX.Element);

function useGoogleMapMarkerIconByType(
    markerType: Toolkit.Theme.GoogleMap.MarkerType,
    iconDefinition?: IconDefinitionProps,
    inline?: boolean,
) {
    return getGoogleMapMarkerIconByType(markerType, { theme: useTheme(), ...iconDefinition }, inline);
}

export default useGoogleMapMarkerIconByType;
